import { render, staticRenderFns } from "./reviseTeam.vue?vue&type=template&id=e4c2497e&scoped=true&"
import script from "./reviseTeam.vue?vue&type=script&lang=js&"
export * from "./reviseTeam.vue?vue&type=script&lang=js&"
import style0 from "./reviseTeam.vue?vue&type=style&index=0&id=e4c2497e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2497e",
  null
  
)

export default component.exports